

export function getStatusMarker(status: 'ok' | 'warning' | 'error' | 'unknown') {
    if (status === 'ok') return '✅';
    if (status === 'warning') return '⚠️';
    if (status === 'error') return '❌';
    return '❔';
}
